import { Weblab } from '@amzn/katal-weblab';
import { WeblabType } from '@amzn/katal-weblab-sellercentral';
import WeblabTreatment from './weblabTreatment';
import WeblabId from './weblabId';

const WEBLAB_LIST: Weblab[] = [
  {
    defaultTreatment: WeblabTreatment.C,
    id: WeblabId.SELLER_FORUMS_PROFILE_ACTIVITY,
    weblabType: WeblabType.Customer,
  },
  {
    defaultTreatment: WeblabTreatment.C,
    id: WeblabId.SELLER_FORUMS_MIDDLEWARE_VALIDATIONS,
    weblabType: WeblabType.Customer,
  },
  {
    defaultTreatment: WeblabTreatment.C,
    id: WeblabId.SELLER_FORUMS_NOTIFICATIONS_SSR,
    weblabType: WeblabType.Customer,
  },
  {
    defaultTreatment: WeblabTreatment.C,
    id: WeblabId.SELLER_FORUMS_HOMEPAGE_SSR,
    weblabType: WeblabType.Customer,
  },
  {
    defaultTreatment: WeblabTreatment.C,
    id: WeblabId.SELLER_FORUMS_HOMEPAGE_ADAPTIVE,
    weblabType: WeblabType.Customer,
  },
  {
    defaultTreatment: WeblabTreatment.C,
    id: WeblabId.SELLER_FORUMS_NAVBAR_ADAPTIVE,
    weblabType: WeblabType.Customer,
  },
  {
    defaultTreatment: WeblabTreatment.C,
    id: WeblabId.SELLER_FORUMS_VIEWPORT_WIDTH_REMOVAL,
    weblabType: WeblabType.Customer,
  },
  {
    defaultTreatment: WeblabTreatment.C,
    id: WeblabId.SELLER_FORUMS_NOTIFICATIONS_ADAPTIVE,
    weblabType: WeblabType.Customer,
  },
  {
    defaultTreatment: WeblabTreatment.C,
    id: WeblabId.SELLER_FORUMS_THREAD_DETAILS_SSR,
    weblabType: WeblabType.Customer,
  },
  {
    defaultTreatment: WeblabTreatment.C,
    id: WeblabId.SELLER_FORUMS_SILENCED_USER_UPDATE_PROFILE_IMAGE,
    weblabType: WeblabType.Customer,
  },
  {
    defaultTreatment: WeblabTreatment.C,
    id: WeblabId.SELLER_FORUMS_THREAD_LISTING_SSR,
    weblabType: WeblabType.Customer,
  },
  {
    defaultTreatment: WeblabTreatment.C,
    id: WeblabId.SELLER_FORUMS_THREAD_DETAIL_SSR_SESSION,
    weblabType: WeblabType.Customer,
  },
];

export default WEBLAB_LIST;
